import React from 'react';
import tpl from '../templates/quickCash';
import BaseQuickCashView from './BaseQuickCashView';
import PropTypes from 'prop-types';
import {canUseDOM} from '../../../helpers/canUseDOM';
import {withSSRData} from '../../../helpers/hoc/withSSRData';

const SCROLL_CONFIG = {
    paramKeys: ['zero', 'salaryplus', 'addcash'],
    stateKey: 'tabSpecialOffer',
    selector: '#special-offers-new-tabs'
};

class QuickCash extends BaseQuickCashView {
    template = tpl;

    constructor(props) {
        super(props);

        this.state = {
            ...this.state,
            search_by: ['/credit/quick_cash'],
            where_by_2: ['path'],
            search_by_2: ['/credit/quick_cash_min_percent'],
            widgets_2: [],
            where_by_3: ['path'],
            search_by_3: ['/credit/quick_cash_salary'],
            widgets_3: [],
            widgets_4: [],
            tabInfo: 'calculator',
            tabSpecialOffer: 'zero',
            tabShortQuestions: 'general-questions-short',
            tabAllQuestions: 'general-questions-full'
        };
    }

    componentWillMount() {
        if (canUseDOM) return;
        const ssrData = this.props.ssrData;
        if (ssrData) {
            this.setState({
                widgets: ssrData.widgets || [],
                widgets_2: ssrData.widgets_2 || [],
                widgets_3: ssrData.widgets_3 || [],
                widgets_4: ssrData.widgets_4 || [],
                loader: false
            });
        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.widgetsHelper.getWidgets_2.call(this);
        this.widgetsHelper.getWidgets_3.call(this);
        this.widgetsHelper.getWidgetsByPath.call(this, {
            path: '/credit/quick_cash_cashplus',
            widgetKey: 'widgets_4'
        });
    }

    onModelLoaded() {
        this.scrollToCalculator();
        this.scrollToAndActivateTab(SCROLL_CONFIG);
        this.unlisten = this.props.history.listen(() => {
            this.scrollToAndActivateTab(SCROLL_CONFIG);
        });
    }

    componentWillUnmount() {
        super.componentWillUnmount();
        if (this.unlisten) this.unlisten();
    }

    toggleInfoTab = tab => {
        this.setState({tabInfo: tab});
    };

    toggleSpecialOffersTab = tab => {
        this.setState({tabSpecialOffer: tab});
    };

    toggleShortQuestionTab = tab => {
        this.setState({tabShortQuestions: tab});
    };

    toggleAllQuestionsTab = tab => {
        this.setState({tabAllQuestions: tab});
    };

    scrollToCalculatorForce = () => {
        this.setState({tabInfo: 'calculator'}, () => {
            this.waitForElement('.calculator-new', element => {
                element.scrollIntoView({block: 'start', behavior: 'smooth'});
            });
        });
    };

    scrollToCalculator = () => {
        if (!window.location.href.includes('quick_cash/calc')) return;
        this.scrollToCalculatorForce();
    };

    static displayName = 'Credit.Views.QuickCash';
}

export default withSSRData(QuickCash);
